import type { SessionListItem } from '@/entities/session';
import { getWeekdayDayAndMonth } from '@/shared/lib/time-utils';

export type RowDecoration = {
    header: { weekday: string; dayAndMonth: string; isDayCompleted: boolean } | null;
    isLastOfDay: boolean;
};

const dayKey = (iso: string) => new Date(iso).toDateString();

export function getRowDecorations(sessions: SessionListItem[]): RowDecoration[] {
    return sessions.map((session, i) => {
        const day = dayKey(session.date);
        const prevDay = i > 0 ? dayKey(sessions[i - 1].date) : null;
        const nextDay = i < sessions.length - 1 ? dayKey(sessions[i + 1].date) : null;

        return {
            header:
                prevDay !== day
                    ? {
                          ...getWeekdayDayAndMonth(new Date(session.date)),
                          isDayCompleted: session.isDayCompleted,
                      }
                    : null,
            isLastOfDay: nextDay !== day,
        };
    });
}
